module.exports = window["__sharedReduxThunk"];